exports.cs = {
  FIELD: {
    INVALID_INPUT: 'Pole není vyplněno správně.',
    ERROR_REQUIRED: 'Zadejte prosím požadované údaje.',
    TOOLTIP_CISLO_UCTU: 'Správný formát čísla účtu se skládá z předčíslí, čísla účtu a kódu banky. Pokud není předčíslí, vyplňte nuly.',
    INVALID_ACCOUNT_NUMBER: 'Neplatné číslo účtu.',
    INVALID_ACCOUNT_PREFIX: 'Neplatné předčíslí účtu.',
    INVALID_BANK_CODE: 'Neplatný kód banky.',
    INVALID_PASTE_ACCOUNT_FORMAT: 'Vložen neplatný formát čísla účtu.'
  }
}
